module.exports = __webpack_public_path__ + "static/pic16-c97a683e37571dd512fbe2a686bac067.png";